/* eslint-disable no-trailing-spaces */
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  stepAction,
  applicantAction,
  submitClicked,
  submitInit,
  catalogueAction,
  fatcaCrsAction,
  personalInformation,
} from 'shared/store/actions';
import { LayoutWithStepper } from 'layouts';
import selectors from 'shared/store/selectors';
import {
  FooterAction,
  Accordion,
  AccordionGroup,
  PageContentWrapper,
  //   Input, PaddedContainer, CheckMark, FormElementContainer, Label,
} from 'components';
import {
  APPLICANT_HISTORY_CODE,
  PATH,
  CLIENT_CLASSIFICATION,
  QUALIFIED_TYPE_OF_INVESTMENT,
  GLOBAL,
} from 'shared/constant';
import validation from 'shared/validations';
import utils from 'shared/helpers/utils';
import { isMobileOnly } from 'react-device-detect';
import {
  ClientDetails,
  Pep,
  BankDetails,
  SourceOfWealth,
  AuthorizedSignatoryInformation,
  ClientProfileForm,
} from './contents';

class PersonalInformation extends Component {
  state = {
    current: 0,
  };

  componentDidMount() {
    const {
      // onUpdateSteps, intl,
      onUpdateCurrentStep,
      isAllStepsCompleted,
      history,
      onGetCatalogue,
    } = this.props;

    /** Redirect to Homepage if all steps are completed else update steps */
    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      // onUpdateSteps(intl);
      onUpdateCurrentStep('step3');
    }

    onGetCatalogue();
  }

  onNext = (e) => {
    const {
      history,
      onUpdateCurrentStep,
      intl,
      clientDetails,
      // clientDetails: {
      //   clientClassification, qualifiedInvestorOptions, typeOfInvestment, product, nationality, dateOfBirth, cityOfBirth, countryOfBirth,
      //   occupation, homeAddress, emailAddress, mobileNumber, employerBusinessName, position, officeAddress,
      // },
      bankDetails: {
        bankName,
        accountName,
        iban,
        currency,
        otherBankName,
        domicileCountry,
        cardInfo,
        usingKNET,
      },
      isPep,
      pepList,
      onSaveApplicant,
      onSubmitClick,
      onSubmitInit,
      onUpdateHistory,
      onSaveProductCode,
      sourceOfWealthDetails: {
        sourceOfWealthFunds,
        estimatedWealth,
        netIncome,
      },
      // asiDetails,
      clientProfileFormDetails,
      // asiDetails: {
      //   isPOAholder, authorityToDeal, poaName, poaAddress, poaEmailAddress, poaNationality, poaDateOfBirth, poaOccupation, poaPosition, poaMobile, poaEmployerBusinessName, poaRelationshipWithClient, poaIsAsUSPerson,
      //   userDOB, isAuthorityToDeal,
      // },
      // clientAge,
      productMinInvestAmountData,
      onAutoUpdateFatca,
      onUpdateASIPoa,
    } = this.props;
    const { current } = this.state;
    const isDiscretionary = !!(
      clientDetails.clientClassification === CLIENT_CLASSIFICATION.QUALIFIED
      && clientDetails.typeOfInvestment
        === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY
    );

    /** CLIENT DETAILS VALIDATION */
    const isClientDetailsValid = validation
      .clientDetailPageSchema(
        intl,
        clientDetails.clientClassification,
        clientDetails.typeOfInvestment,
        clientDetails.product,
        clientDetails.investmentStrategies,
        clientDetails.assetAllocations,
        productMinInvestAmountData,
        clientDetails.occupation,
      )
      .isValidSync({ ...clientDetails });

    /** BANK DETAILS VALIDATION */
    const isBankDetailsValid = validation
      .bankDetailPageSchema(intl, bankName)
      .isValidSync({
        bankName,
        accountName,
        iban,
        currency,
        otherBankName,
        domicileCountry,
      });
    const isCardsValid = ((clientDetails.typeOfInvestment === 'NW-MAR-IEY-OLT'
        || clientDetails.typeOfInvestment === 'NW-MAR-CLA-OLT')
      && usingKNET === 'true'
      // First card is required; additional cards are optional but must be complete & valid once started
      && cardInfo.every((item, index) => {
        const isEmpty = !item.lastFourDigits && !item.value;
        if (index > 0 && isEmpty) return true;
        return utils.isLastFourDigitsValid(item.lastFourDigits)
          && utils.isCardMonthYearValid(item.value?.replace(/\//g, ''));
      })) || ((clientDetails.typeOfInvestment === 'NW-MAR-IEY-OLT'
        || clientDetails.typeOfInvestment === 'NW-MAR-CLA-OLT') && usingKNET === 'false');

    /**
     * PEP VALIDATION
     * @Todo display peplist error when invalid
     * */
    const isPepValid = validation
      .pepPageSchema(
        intl,
        isPep,
        clientDetails.clientClassification,
        clientDetails.typeOfInvestment,
      )
      .isValidSync({
        isPep,
        list: pepList,
        insiderStatus: clientProfileFormDetails.insiderStatus,
        clientClassification: clientDetails.clientClassification,
        typeOfInvestment: clientDetails.typeOfInvestment,
      });
    // console.log('isPepValid ', isPepValid);
    // const isPepValid = validation.pepListSchema(intl, isPep).isValidSync({ list: pepList });
    /** SOURCE OF WEALTH VALIDATION */
    const isSourceOfWealthValid = validation
      .sourceOfWealthPageSchema(
        intl,
        sourceOfWealthFunds,
        estimatedWealth,
        netIncome,
      )
      .isValidSync({
        ...this.props.sourceOfWealthDetails,
      });

    /** AUTHORIZED SIGNATORY INFORMATION VALIDATION */
    // const isAsiValid = validation
    //   .asiPageSchema(
    //     intl,
    //     asiDetails.isPOAholder,
    //     clientAge,
    //     asiDetails.authorityToDeal,
    //     asiDetails.poaOccupation,
    //   )
    //   .isValidSync({
    //     ...asiDetails,
    //   });

    // const isClientProfileValid = validation.clientProfilePageSchema(intl, )
    const isClientProfileFormValid = validation
      .clientProfilePageSchema(
        intl,
        isDiscretionary,
        clientProfileFormDetails.restrictions,
      )
      .isValidSync({ ...clientProfileFormDetails });
    const isInsiderListValid = validation
      .insiderListSchema(intl, clientProfileFormDetails.insiderStatus)
      .isValidSync({
        insiderStatusList: clientProfileFormDetails.insiderStatusList,
      });

    utils.scrollToError();

    switch (current) {
      case 0:
        onSubmitClick();
        if (isClientDetailsValid) {
          onSubmitInit();
          onSaveApplicant(false);
          onUpdateHistory(
            APPLICANT_HISTORY_CODE.SUBMIT_DETAILS.code,
            APPLICANT_HISTORY_CODE.SUBMIT_DETAILS.codeI18n,
          );

          /** clear product code after saving client details */
          onSaveProductCode('');

          if (
            clientDetails.nationality === 'Kuwaiti'
            && clientDetails.countryOfBirth === 'Kuwait'
          ) {
            onAutoUpdateFatca();
            onUpdateASIPoa('isPOAholder', 'no');
          }

          this.setState({ current: 1 });
        }
        break;
      case 1:
        onSubmitClick();
        if (isPepValid && isInsiderListValid) {
          // console.log('isPepValid', isPepValid, isInsiderListValid);
          onSubmitInit();
          onSaveApplicant(false);
          this.setState({ current: 2 });
        }
        break;
      case 2:
        onSubmitClick();
        if ((isBankDetailsValid && !((clientDetails.typeOfInvestment === 'NW-MAR-IEY-OLT'
            || clientDetails.typeOfInvestment === 'NW-MAR-CLA-OLT'))) || (isBankDetailsValid && isCardsValid)) {
          onSubmitInit();
          onSaveApplicant(false);
          this.setState({ current: 3 });
        }
        break;
      case 3:
        onSubmitClick();
        if (isSourceOfWealthValid) {
          onSubmitInit();
          onSaveApplicant(false);
          // this.setState({ current: 4 });
          this.setState({ current: 5 });
        }
        break;
      case 4:
        // onSubmitClick();
        // if (isAsiValid) {
        //   onSubmitInit();
        //   onSaveApplicant(false);
        //   this.setState({ current: 5 });
        // }
        break;
      case 5:
        onSubmitClick();
        // console.log('CALLED testing', isClientDetailsValid, isPepValid, isBankDetailsValid, isSourceOfWealthValid, isAsiValid, isClientProfileFormValid, isInsiderListValid);
        if (
          isClientDetailsValid
          && isPepValid
          && isBankDetailsValid
          && isSourceOfWealthValid
          // && isAsiValid
          && isClientProfileFormValid
          && isInsiderListValid
        ) {
          onUpdateCurrentStep('step4');
          onSaveApplicant(false).then(() => {
            onUpdateHistory(
              APPLICANT_HISTORY_CODE.SUBMIT_PROFILE.code,
              APPLICANT_HISTORY_CODE.SUBMIT_PROFILE.codeI18n,
            );
            history.push(PATH.FATCA_CRS);
          });
        }
        break;
      default:
        this.setState(prevState => ({
          current: prevState.current,
        }));
    }

    this.props.onUpdateSteps(intl);
    e.preventDefault();
    // if (current === 5) {
    //   onUpdateCurrentStep('step4');
    //   history.push(PATH.FATCA_CRS);
    // }
    // this.setState(prevState => ({
    //   current: prevState.current + 1,
    // }));
  };

  render() {
    const {
      intl,
      clientDetails,
      clientAge,
      isPep,
      pepList,
      bankDetails,
      sourceOfWealthDetails,
      asiDetails,
      clientProfileFormDetails,
      productMinInvestAmountData,
    } = this.props;
    const { current } = this.state;
    const {
      clientDetailPageSchema,
      bankDetailPageSchema,
      pepPageSchema,
      sourceOfWealthPageSchema,
      asiPageSchema,
      clientProfilePageSchema,
      insiderListSchema,
    } = validation;
    const isDiscretionary = !!(
      clientDetails.clientClassification === CLIENT_CLASSIFICATION.QUALIFIED
      && clientDetails.typeOfInvestment
        === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY
    );
    const isClientDetailsCompleted = clientDetailPageSchema(
      intl,
      clientDetails.clientClassification,
      clientDetails.typeOfInvestment,
      clientDetails.product,
      clientDetails.investmentStrategies,
      clientDetails.assetAllocations,
      productMinInvestAmountData,
      clientDetails.occupation,
    ).isValidSync({ ...clientDetails });
    const isBankDetailsCompleted = bankDetailPageSchema(
      intl,
      bankDetails.bankName,
    ).isValidSync({ ...bankDetails });
    const isPepCompleted = pepPageSchema(
      intl,
      isPep,
      clientDetails.clientClassification,
      clientDetails.typeOfInvestment,
    ).isValidSync({
      isPep,
      list: pepList,
      insiderStatus: clientProfileFormDetails.insiderStatus,
      clientClassification: clientProfileFormDetails.clientClassification,
      typeOfInvestment: clientProfileFormDetails.typeOfInvestment,
    });

    const isSourceOfWealthCompleted = sourceOfWealthPageSchema(
      intl,
      sourceOfWealthDetails.sourceOfWealthFunds,
      sourceOfWealthDetails.estimatedWealth,
      sourceOfWealthDetails.netIncome,
    ).isValidSync({ ...sourceOfWealthDetails });
    const isAsiCompleted = asiPageSchema(
      intl,
      asiDetails.isPOAholder,
      clientAge,
      asiDetails.authorityToDeal,
      asiDetails.poaOccupation,
    ).isValidSync({ ...asiDetails });
    const isClientProfileFormCompleted = clientProfilePageSchema(
      intl,
      isDiscretionary,
      clientProfileFormDetails.restrictions,
    ).isValidSync({ ...clientProfileFormDetails });
    const isInsiderListCompleted = insiderListSchema(
      intl,
      clientProfileFormDetails.insiderStatus,
    ).isValidSync({ insiderStatusList: clientProfileFormDetails.insiderList });

    const footer = (
      <FooterAction
        isDisabled={clientAge < GLOBAL.CLIENT_MIN_AGE}
        isSingleButton
        rightButton={intl.formatMessage({ id: 'saveContinue' })}
      />
    );

    return (
      <form onSubmit={this.onNext} id="wrap-from">
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container">
            <AccordionGroup
              current={current}
              onAccordionToggle={e => this.setState({ current: e })}
            >
              <Accordion
                isCompleted={isClientDetailsCompleted}
                title={intl.formatMessage({ id: 'clientDetails' })}
                content={<ClientDetails />}
              />
              <Accordion
                isCompleted={isPepCompleted}
                title={intl.formatMessage({ id: 'pep' })}
                level="II"
                content={<Pep />}
              />
              <Accordion
                isCompleted={isBankDetailsCompleted}
                title={intl.formatMessage({ id: 'bankDetails' })}
                level="III"
                content={<BankDetails />}
              />
              <Accordion
                isCompleted={isSourceOfWealthCompleted}
                title={intl.formatMessage({ id: 'sourceOfWealth' })}
                level="IV"
                content={<SourceOfWealth />}
              />
              <Accordion
                isCompleted={isAsiCompleted}
                title={intl.formatMessage({ id: 'asi' })}
                level="V"
                isHidden
                content={<AuthorizedSignatoryInformation />}
              />
              <Accordion
                isCompleted={
                  isClientProfileFormCompleted && isInsiderListCompleted
                }
                title={intl.formatMessage({ id: 'clientProfileForm' })}
                level="VI"
                content={<ClientProfileForm />}
              />
            </AccordionGroup>
          </div>
          {!isMobileOnly && footer}
        </PageContentWrapper>
        {isMobileOnly && footer}
      </form>
    );
  }
}

const mapStateToProps = state => ({
  clientDetails: selectors.getClientDetails(state),
  clientAge: selectors.getAge(state),
  isPep: selectors.getisPep(state),
  pepList: selectors.getPepList(state),
  bankDetails: selectors.getBankDetails(state),
  sourceOfWealthDetails: selectors.getSourceOfWealthDetails(state),
  asiDetails: selectors.getAsiDetails(state),
  clientProfileFormDetails: selectors.getClientProfileFormDetails(state),
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  productMinInvestAmountData: selectors.getProductMinInvestAmountData(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onSaveApplicant: isGenerate => dispatch(applicantAction.updateApplicant(isGenerate)),
  onSaveProductCode: id => dispatch(applicantAction.saveProductCode(id)),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
  onSubmitClick: () => dispatch(submitClicked()),
  onSubmitInit: () => dispatch(submitInit()),

  onGetCatalogue: () => dispatch(catalogueAction.fetchCatalogue()),
  onSelectedProduct: id => dispatch(catalogueAction.selectedProduct(id)),
  onAutoUpdateFatca: () => dispatch(fatcaCrsAction.autoUpdateFatca()),
  onUpdateASIPoa: (name, value) => dispatch(personalInformation.updateAsi(name, value)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LayoutWithStepper(injectIntl(PersonalInformation)));
